import * as T from '../constants/types';

export const onChangeLoginForm = ({ target: { id, value } }) => (dispatch, getState) => {
    const { loginForm } = getState();
    dispatch({ type: T.CHANGE_LOGIN_FORM, payload: { ...loginForm, [id]: value } });
};
